/* rtf-pdp-buybox.js
   Tidies the above-the-fold buy box toward the approved mockup. Display-only;
   the cart form and subscription logic are untouched.
   1. Lifts the delivery ETA from the lead-time estimator up under the price
      (into rtf-pdp-buymeta) and hides the old bulky card.
   2. Removes a stray "(N Reviews)" duplicate (our stars already show it).
   3. Shows the "Subscribe & save" selector only when the product actually has
      selling plans (some products aren't enrolled — no fake selector there).
   4. Moves the trust row out of the main buy-box card, below it. */
(function () {
  function leadEl() {
    return Array.prototype.slice
      .call(document.querySelectorAll('.product__info-wrapper *'))
      .find(function (e) {
        // the real lead-time estimator reads "Estimated delivery: <Month> <day>…";
        // exclude our own buymeta element (which just says "Estimated delivery").
        return !e.closest('[data-rtf-buymeta]') &&
          /Estimated delivery:\s*[A-Za-z]{3,}/i.test(e.textContent) &&
          e.children.length <= 12 && e.textContent.length < 400;
      });
  }

  function hasSellingPlans() {
    var el = document.querySelector('[data-selected-variant]');
    if (el) {
      try {
        var v = JSON.parse(el.textContent || '{}');
        if (v && v.selling_plan_allocations && v.selling_plan_allocations.length) return true;
      } catch (e) {}
    }
    // fallback: native selling-plan input or a selling_plan_groups blob on the page
    if (document.querySelector('input[name="selling_plan"], select[name="selling_plan"], [data-selling-plan-id]')) return true;
    var found = false;
    document.querySelectorAll('script[type="application/json"]').forEach(function (s) {
      if (/"selling_plan_groups"\s*:\s*\[\s*\{/.test(s.textContent)) found = true;
    });
    return found;
  }

  function run() {
    // 1. lift the ETA up beside the price
    var eta = document.querySelector('[data-rtf-eta]');
    var wrap = document.querySelector('[data-rtf-buymeta]');
    var lead = leadEl();
    if (eta && wrap && !eta.__done && lead) {
      var m = lead.textContent.match(/Estimated delivery:\s*([A-Za-z]{3,}\.?\s*\d{1,2})(?:\s*[–—-]\s*([A-Za-z]{3,}\.?\s*\d{1,2}))?/);
      if (m) {
        // Lead with the EARLIEST arrival date (urgency-forward, matches the site's "reorder in
        // seconds" promise); keep the far end of the window in muted text for honesty.
        eta.textContent = m[1].replace(/\s+/g, ' ').trim();
        var rangeEl = document.querySelector('[data-rtf-eta-range]');
        if (rangeEl) rangeEl.textContent = m[2] ? '(through ' + m[2].replace(/\s+/g, ' ').trim() + ')' : '';
        wrap.hidden = false;
        eta.__done = true;
        // Now hide the ORIGINAL delivery display (its date has been lifted by the price).
        // It renders either as a border-left card OR a whole themed .product__info-panel;
        // prefer hiding the panel (the blank white box) when it only holds the estimator.
        var panel = lead.closest('.product__info-panel');
        if (panel && panel.textContent.length < 700 && !/Add to cart|Subscribe|Buy with|selling_plan|Quantity/i.test(panel.textContent)) {
          panel.style.display = 'none';
        } else {
          var card = lead;
          for (var i = 0; i < 5 && card.parentElement; i++) {
            if (/border-left/i.test(card.getAttribute('style') || '')) break;
            card = card.parentElement;
          }
          if (card && /border-left/i.test(card.getAttribute('style') || '')) card.style.display = 'none';
        }
      }
    }

    // 2. drop the stray "(N Reviews)" duplicate
    Array.prototype.slice.call(document.querySelectorAll('.product__info-wrapper *')).forEach(function (c) {
      if (!c.__rtfDup && c.children.length === 0 && /^\(\s*[\d,]+\s*Reviews?\s*\)$/i.test((c.textContent || '').trim())) {
        c.__rtfDup = true;
        c.style.display = 'none';
      }
    });

    // 3. hide the theme's old collapsible "Subscribe & save" selector (class
    //    rtf-subscription*) — replaced by our rtf-pdp-subscribe toggle.
    Array.prototype.slice.call(document.querySelectorAll('[class^="rtf-subscription"], [class*=" rtf-subscription"]')).forEach(function (el) {
      if (el.__subHidden || el.closest('[data-rtf-sub]')) return;
      el.__subHidden = true;
      el.style.display = 'none';
    });

    // 4. move the trust row out of the main buy-box card, below it.
    //    The credibility strip renders directly above the row in the same
    //    snippet and has to travel with it — moving the row alone left the
    //    strip inside the card, indented 40px from the row beneath it.
    var tr = document.querySelector('.rtf-trustrow');
    if (tr && !tr.__moved) {
      var box = tr.closest('.product__info-padded-main') || tr.closest('.product__info-container.card--shadow');
      if (box && box.parentElement) {
        var cred = document.querySelector('.rtf-cred--inline');
        box.parentElement.insertBefore(tr, box.nextSibling);
        if (cred) box.parentElement.insertBefore(cred, tr);   // keep strip above row
        tr.classList.add('rtf-trustrow--outside');
        tr.__moved = true;
      }
    }

    // 5. once the ETA has been lifted, the old lead-time panel is empty — hide the
    //    resulting blank white box. Gated on eta.__done so we never hide a panel
    //    that is still waiting to populate.
    if (eta && eta.__done) {
      Array.prototype.slice.call(document.querySelectorAll('.product__info-wrapper .product__info-panel')).forEach(function (el) {
        if (el.__rtfEmpty) return;
        var txt = (el.textContent || '').replace(/\s+/g, '').length;
        if (txt < 2 && !el.querySelector('img, svg, input, button, select, video, iframe')) {
          el.__rtfEmpty = true;
          el.style.display = 'none';
        }
      });
    }
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  document.addEventListener('variant:change', run);
  // the lead-time estimator fills its date via JS after load — retry until lifted
  var tries = 0;
  var iv = setInterval(function () {
    run();
    tries++;
    var e = document.querySelector('[data-rtf-eta]');
    if ((e && e.__done) || tries >= 10) clearInterval(iv);
  }, 400);
})();
